import { apiFetch } from "../useApi";

export default async function retryAddresses() {
  const response = await apiFetch(`/addresses/retry`, {
    method: 'PUT',
  });
  return response.json();
}
